import { AppConfigurationDtoToEntity } from "src/app/features/ApplicationConfigurations/services/mappers/AppConfigurationDtoToEntity";
import { AppConfigurationEntityToDto } from "src/app/features/ApplicationConfigurations/services/mappers/AppConfigurationEntityToDto";
import type { DataGroupRequest, FormJson } from "src/app/features/ApplicationConfigurations/types/AppConfigsTypes";
import type { AppConfigurationDto } from "src/app/features/ApplicationConfigurations/types/AppConfigurationDto";
import type { AppConfigurationEntity } from "src/app/features/ApplicationConfigurations/types/AppConfigurationEntity";
import { getAssignedDataGroup } from "../../../../../core/router/auth/SecurityManager";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { GenericObject } from "../../../../../core/types";

export const defaultAppConfigApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        loadAppConfig: builder.query<AppConfigurationEntity, DataGroupRequest>({
            providesTags: ["appConfigurations"],
            query: ({ dataGroupCode }) => {
                const url = `${ResourceName.DATA_GROUPS}/${dataGroupCode}/${ResourceName.APP_CONFIGURATIONS}`;
                return {
                    url,
                    method: "GET",
                };
            },
            transformResponse: (response: AppConfigurationDto) => {
                return AppConfigurationDtoToEntity(response);
            },
        }),
        saveAppConfig: builder.mutation<GenericObject, FormJson>({
            query: (formJson) => {
                const dataGroup = getAssignedDataGroup();
                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.APP_CONFIGURATIONS}`;
                const method = "PUT";

                const body = AppConfigurationEntityToDto(formJson);
                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: ["appConfigurations", "mainCache"],
        }),
    }),
});

export const { useLoadAppConfigQuery, useSaveAppConfigMutation } = defaultAppConfigApi;
